import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LauncherContentComponent } from '@layout/launcher/components/launcher-content/launcher-content.component';
import { TooltipDirective } from '@kaseya-design-components';
import { LauncherPanelComponent } from '@layout/launcher/components/launcher-panel/launcher-panel.component';
import { LauncherModulesFacade } from '@layout/launcher/facades/launcher-modules.facade';

@Component({
  selector: 'itc-launcher',
  templateUrl: 'launcher.component.html',
  styleUrl: 'launcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, TranslatePipe, LauncherContentComponent, LauncherPanelComponent],
  host: {
    '(keydown.escape)': 'closeAndFocusTrigger()',
    '(focusout)': 'hideLauncherOnFocusOut($event)',
  },
})
export class LauncherComponent {
  private readonly elementRef = inject(ElementRef);
  private readonly launcherModulesFacade = inject(LauncherModulesFacade);
  private readonly trigger = viewChild.required<ElementRef<HTMLButtonElement>>('trigger');
  readonly isVisible = this.launcherModulesFacade.isVisible;

  toggleLauncher(): void {
    this.launcherModulesFacade.toggleLauncherVisibility();
  }

  closeAndFocusTrigger(): void {
    if (!this.isVisible()) {
      return;
    }

    this.launcherModulesFacade.hideLauncher();
    this.trigger().nativeElement.focus();
  }

  hideLauncherOnFocusOut({ relatedTarget }: FocusEvent): void {
    if (relatedTarget && !this.elementRef.nativeElement.contains(relatedTarget)) {
      this.launcherModulesFacade.hideLauncher();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const targetComposedPath = event.composedPath();

    if (!targetComposedPath.includes(this.elementRef.nativeElement)) {
      this.launcherModulesFacade.hideLauncher();
    }
  }

  @HostListener('window:popstate')
  onWindowNavigation(): void {
    this.launcherModulesFacade.hideLauncher();
  }
}
